// utils.js
export function maskEmail(email) {
    if (!email || typeof email !== 'string') {
        return '';
    }
    const [user, domain] = email.split('@');
    const maskedUser = user[0] + '*'.repeat(user.length - 2) + user[user.length - 1];
    return `${maskedUser}@${domain}`;
}
